import * as yup from 'yup'

function isValidNumberAndDot(this: yup.StringSchema, message: string) {
  return this.test('isValidNumberAndDot', message, function (value) {
    const { path, createError } = this

    if (value && !value.match(/^[0-9]*\.?[0-9]*$/)) {
      return createError({
        path,
        message,
      })
    }

    return true
  })
}

declare module 'yup' {
  interface StringSchema {
    isValidNumberAndDot(message: string): StringSchema
  }
}

yup.addMethod(yup.string, 'isValidNumberAndDot', isValidNumberAndDot)

export default yup
